import { Input } from "ui-components/input";

import { Field } from "ui-components/field";
import { FieldLabel } from "ui-components/field-label";
import { Icon } from "ui-components/icon";
import { InputGroup } from "ui-components/input";

const EmailInput = ({
  onEmailChange,
  email,
  onEmailBlur
}: {
  onEmailChange: (email: string) => void;
  email: string;
  onEmailBlur?: () => void;
}) => {
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onEmailChange(e.target.value);
  };
  return (
    <Field className="w-full">
      <FieldLabel>Email address</FieldLabel>
      <InputGroup>
        <Icon name="EnvelopeIcon" className="opacity-50" />
        <Input
          name="email_address"
          type="email"
          onBlur={onEmailBlur}
          onChange={handleEmailChange}
          value={email}
          required
          className="w-full"
          placeholder="Email address"
        />
      </InputGroup>
    </Field>
  );
};

export default EmailInput;
